import { createTheme, colors } from "@material-ui/core";

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    body1: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    body2: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    h1: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    h2: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    h3: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    h4: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    h5: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    h6: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    },
  },

  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [
          {
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontDisplay: "swap",
            fontWeight: 400,
            src: `
              local('Poppins'),
              url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap') format('woff2')
            `,
          },
        ],
      },
    },
  },

  UpdateTheme: {
    button_color: "#FFC62D",
    text_color: "#263238",
    heading_color: "#263238",
    theme_color: "#263238",
    link_color: "#1295EE",
    table_head_color: "#f2f2f6",
  },

  palette: {
    background: {
      dark: "transparent",
      default: colors.common.white,
      paper: colors.common.white,
      dmode: "rgb(251, 251, 255)",
      even: "#F4F6F8",
      reportbg: "#f9f9f9",
    },
    header: {
      bg: "#FFFFFF",
      text: "#000",
    },
    leftBar: {
      bg: "rgb(6, 2, 54)",
      text: "#FFFFFF",
      active: "#FFC62D",
    },
    primary: {
      main: colors.indigo[500],
    },
    secondary: {
      main: colors.indigo[500],
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
      border: "#dcdcdc",
      primary2: colors.blueGrey[600],
    },
    button: {
      borderRadius: "20px",
      color: "#000",
      background: "#FFC62D",
      fontWeight: "500",
      fontSize: "16px",
      paddingRight: "20px",
      paddingLeft: "20px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#FFC62D",
      },
    },
    buttonSecondary: {
      borderRadius: "20px",
      color: "#FFFFFF",
      background: "#060236",
      fontWeight: "500",
      fontSize: "16px",
      paddingRight: "20px",
      paddingLeft: "20px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#060236",
      },
    },
  },
  borders: {
    custombbottom: "6px solid #fff",
    assesbbottom: "10px solid #fff",
  },
});

export default theme;
